import Icon from '../components/Icon.vue'

Icon.register({
  'chevron-up': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M241 130.5l194.3 194.3c9.4 9.4 9.4 24.6 0 33.9l-22.7 22.7c-9.4 9.4-24.5 9.4-33.9 0l-154.7-154-154.7 154c-9.4 9.3-24.5 9.3-33.9 0l-22.7-22.7c-9.4-9.4-9.4-24.6 0-33.9l194.3-194.3c9.4-9.4 24.6-9.4 33.9 0z'
      }
    ]
  }
})
